export class AssetIssue {

  issueType: number;
  name: string;
  shortName: string;

  public static fromJsonString(jsonString: any): AssetIssue {
    return Object.assign(new AssetIssue(), jsonString);
  }

}
